module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Compétences techniques","b":"Vide.","c":"Aucune compétence technique."},"en":{"a":"Technical skills","b":"Empty.","c":"No technical skill."}}')
  delete Component.options._Ctor
}
